import $ from 'jquery'
import Backbone from 'backbone'
import i18n from 'scoreboard/components/i18n'
import readFile from 'scoreboard/components/read-file'
import scoreboardUrl from 'scoreboard/components/scoreboard-url'
import fileInfo from 'scoreboard/components/files/file-info'
import pickerTemplate from './image-picker.hbs'

/**
 *
 * @emits 'pick' when a new image is chosen.
 * @emits 'delete' when an images is removed.
 */
const ImagePicker = Backbone.View.extend({

	className: 'image-picker',

	events: {
		'click .delete': 'delete',
		'click .upload': 'upload',
		'change .image-file': 'onChangeImageFile'
	},

	/**
	 *
	 * @param {String} [options.uploadLabelKey='documents.upload.upload']
	 * @param {String} [options.deleteLabelKey='common.delete']
	 * @param {String} [options.imgClass='image-picker-image'] a class to add
	 * to the img element
	 */
	initialize(options = {}) {
		this.options = options
		this.uploadLabel = i18n.get(options.uploadLabelKey || 'documents.upload.upload')
		this.deleteLabel = i18n.get(options.deleteLabelKey || 'common.delete')
		this.imgClass = options.imgClass || 'image-picker-image'
	},

	render: function () {
		this.$el.append(pickerTemplate({
			uploadLabel: this.uploadLabel,
			deleteLabel: this.deleteLabel,
			smallButtons: this.options.smallButtons,
			accept: fileInfo.accepts['image']
		}))

		this._updateControls()
		return this
	},

	onChangeImageFile: function(e) {
		readFile(e.target.files, this._picked.bind(this))
	},

	/**
	 * Invoked when a new image is selected by the user
	 */
	_picked(filename, dataUri) {
		if (!filename) {
			// If user clicked Cancel in file picker dialog, the callback is called
			// with no arguments. In that case, do nothing
			return
		}

		this._getOrCreateImg().attr('src', dataUri)

		this.trigger('pick', {
			dataUri: dataUri,
			name: filename
		})

		// Wait till the selected image is visible before repositioning the upload controls
		process.nextTick(this._updateControls.bind(this))
	},

	/**
	 * Invoke to create the image if one exists, and show the correct buttons
	 * for the given state.
	 *
	 * @param id The id of the image (/api/images/{id})
	 */
	imageId(id) {
		if (id) {
			this._getOrCreateImg().attr('src', imgSrc(id))
		} else {
			this.$(`.${this.imgClass}-container`).remove()
		}

		this._updateControls()
	},

	_updateControls() {
		var hasImage = this.$('img').length > 0

		this.$('.no-image').toggleClass('is-not-displayed', hasImage)
		this.$('.delete').toggleClass('is-not-displayed', !hasImage)
	},

	// Trigger the file upload selection when the upload button is clicked
	upload: function() {
		this.$('.image-file').click()
	},

	'delete': function () {
		this.imageId(null)
		this.trigger('delete')
	},

	_getOrCreateImg() {
		var img = this.$('img')
		if (img.length == 0) {
			let imgContainer = $(`<div class="${this.imgClass}-container"><img class="${this.imgClass}"></div>`)
			this.$el.prepend(imgContainer)
			img = this.$('img')
		}

		return img
	}
})

/**
 * @param {Number} id
 * @param {String} defaultUrl If the id is not defined and another default image url should be used
 * (e.g. /resoures/images3/project.svg)
 *
 * @return the String to assign an <img> src attribute to be served from the API
 * undefined if no src is available
 */
function imgSrc(id, defaultUrl) {
	if (id) {
		return scoreboardUrl('api/images/' + id)
	} else if (defaultUrl) {
		return scoreboardUrl(defaultUrl)
	}
}

ImagePicker.imgSrc = imgSrc

export default ImagePicker
ImagePicker.__filename__ = 'components/image-picker.js'
